import { render, staticRenderFns } from "./ComparisonArea.vue?vue&type=template&id=2a73e4e1&"
import script from "./ComparisonArea.vue?vue&type=script&lang=js&"
export * from "./ComparisonArea.vue?vue&type=script&lang=js&"
import style0 from "./ComparisonArea.vue?vue&type=style&index=0&id=2a73e4e1&prod&module=true&lang=css&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports